import { render } from "./AddNewLink.vue?vue&type=template&id=dedc66ca"
import script from "./AddNewLink.vue?vue&type=script&lang=js"
export * from "./AddNewLink.vue?vue&type=script&lang=js"

import exportComponent from "/builds/weborigo-projects/vivien-vance/webshop/core-editor/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__